<template>
  <div class="h-full">
    <section class="cover flex flex-col items-center justify-center text-white text-center px-4">
      <p class="text-4xl -mt-5 mb-16">Forgot password</p>

      <form
        class="flex flex-col items-center max-w-sm w-full"
        @submit.prevent="handleSendPasswordResetEmail"
      >
        <base-input
          v-model="email"
          v-validate="'required|email'"
          name="email"
          class="w-full"
          inputClass="bg-gray-500 text-white"
          placeholder="Email"
          :message="errors.first('email')"
        />

        <button class="btn w-40 my-16" :disabled="isLoading">Send Email</button>
      </form>
    </section>

    <base-footer />
  </div>
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  data() {
    return {
      email: '',
      isLoading: false,
    };
  },
  methods: {
    async handleSendPasswordResetEmail() {
      try {
        if (this.isLoading || !await this.$validator.validateAll()) {
          return;
        }

        this.isLoading = true;

        await AuthService.sendPasswordResetNotification(this.email);

        this.$toasted.show('Email sent!');
        this.$router.push({ name: 'login' });
      } catch(e) {
        this.$toasted.error(e.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.cover {
  background-image: url("/images/background.jpg");
  height: calc(100% - 64px);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
